module.exports = __webpack_public_path__ + "static/media/ijoystick.471c0040.png";